'use strict';
var parent = require('../../actual/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/assign.js
// module id = 360
// module chunks = 0